import TableDataNotFound from "component/TableDataNotFound";
import moment from "moment";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { AppointmentStatus, AppointmentStatusColor } from "utils/constants";
import { handleListResponse, isEmpty, seo } from "utils/utils";
import { getAppointmentList,getAppointmentListForAdmin } from "../../reduxStore/action/appointmentActions";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import Select from "react-select";
import usePage from "utils/usePage";
import ExcelJS from 'exceljs';

const TodayAppointment = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [appointmentData, setAppointmentData] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [page, setPage] = usePage();
  const dispatch = useDispatch();
  const appointmentListSelector = useSelector((state) => state.appointment);
  const { loading, response } = appointmentListSelector;
  const ReportListSelector = useSelector((state) => state.report);
  const [res,setRes] = useState(true)

  

  const { view, create, edit } = usePermission({
    view: "view_appointment",
    create: "add_appointment",
    edit: "edit_appointment",
  });

  useLayoutEffect(() => {
    dispatch(getAppointmentList({
      start_date: new Date().toISOString().split('T')[0], // Format to 'YYYY-MM-DD'
      end_date: new Date().toISOString().split('T')[0]    // Format to 'YYYY-MM-DD'
    }));
    

  }, [dispatch, page]);




  
  useEffect(() => {
    const responseData = response;
    if (responseData?.status === 200) {
      setRes(false)
    
      const data = responseData?.data || [];
     
      if (data.length > 0) {
        setAppointmentData(handleListResponse(data) ? data : []);
      
      } else {
        setAppointmentData([]);
       
      }
    } else if(responseData?.status === 201) {
      setRes(true)
    
      setAppointmentData([]);
    
    }else {
   
      setRes(true)
      setAppointmentData([]);
    }
  }, [appointmentListSelector, response,res]);


 
  

 

 
//   const handlePageClick = (newOffset) => {
//     setPage(newOffset);
//     dispatch(
//       getAppointmentList({
//         appointment_type: 2,
//         limit: 10,
//         offset: newOffset,
//         start_date: form.start_date,
//         end_date: form.end_date,
//         appointment_with: form.appointment_with,
//         customer_name: form.customer_name,
//         status: form.status,
//         property_name: form?.site?.property_title,
//       })
//     );
//   };
  

 

  useEffect(() => {
    seo({
      title: "Appointment Listing",
      metaDescription: "Appointment listing",
      canonicalLink: window.location.href,
    });
  }, []);



  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.todayAppointments}
        titleactive={strings.appointmentList}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
        
            { create && (
              <div className="row pt-3">
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage("/add_appointment")}
                    >
                      {strings.addAppointment}
                    </button>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage(-1)}
                    >
                      {strings.allAppointment}
                    </button>
                  </div>
                </div>
              </div>
            )}
            
            
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                <div className="card-header">
                  <h5>{strings.listofappointment}</h5>
                </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead>
                        <tr className="text-center">
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.siteVisitTimeDate}</th>
                          <th scope="col">{strings.property_name}</th>
                          <th scope="col">{strings.customerName}</th>
                          {/* <th scope="col">{strings.pickup}</th> */}
                          <th scope="col">{strings.source} </th>
                          <th scope="col">{strings.closingStatus}</th>
                          <th scope="col">{strings.checkInStatus}</th>
                          <th scope="col">{strings.visitingScore}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {appointmentData?.length > 0 ? (
                          appointmentData.map((item, index) => {
                            const chekin = !isEmpty(item?.checkin_status)
                              ? item?.checkin_status[0]
                              : "";
                            return (
                              <tr key={index}>
                                <td>
                                {item.createdDate ? moment(item.createdDate).format("DD-MM-yyyy hh:mm A") : ""}
                                </td>
                                <td>
                                  {moment(item.appointment_date).utc().format(
                                    "DD-MM-yyyy"
                                  ) +
                                    " & " +
                                    item.appointment_time}
                                </td>
                                <td style={{ inlineSize: "130px" }}>{item?.property_title}</td>
                                <td style={{ inlineSize: "130px" }}>{item?.customer_first_name}</td>
                                <td style={{ inlineSize: "130px" }}>{item?.create_by}</td>
                                <td
                                  style={{
                                    color: AppointmentStatusColor[item?.status],
                                    fontWeight: "600",
                                  }}
                                >
                                  {Number(item?.status) === 1
                                    ? (moment()) >=
                                      (moment(
                                        moment(item.appointment_date).utc().format(
                                          "DD-MM-yyyy"
                                        ) +
                                        " " +
                                        item.appointment_time, "DD-MM-yyyy hh:mm A"
                                      ))
                                      ? "Notvisited"
                                      : "Upcoming"
                                    : Number(item?.status) === 3 ?
                                      handleListResponse(item?.booking_status).includes(1) ?
                                        'Ready to Book' : 'Booking' :
                                      AppointmentStatus[item?.status]}
                                </td>
                                <td
                                  style={{
                                    color: chekin ? "green" : "black",
                                    fontWeight: "600",
                                  }}
                                >
                                  {chekin ? "Visited" : "-"}
                                </td>
                                <td>{item?.lead_score}</td>
                                <td className="p-2">
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon p-1"
                                      aria-hidden="true"
                                      title={"View Appointment"}
                                      onClick={() =>
                                        navigatpage(
                                          `/viewappointment/${item._id}`
                                        )
                                      }
                                    ></i>
                                  )}
                                  {item.status === 1
                                    ? 
                                    edit && (
                                      <i
                                        className="fa fa-edit theme-fa-icon p-1"
                                        aria-hidden="true"
                                        title="Edit Appointment"
                                        onClick={() =>
                                          navigatpage(
                                            `/editappointment/${item._id}`
                                          )
                                        }
                                      ></i>
                                    )
                                    : ""}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    { appointmentData.length === 0 ? (
  <div className="text-center mt-4 mb-3">No data available</div>
) : (
  // Render your content here when appointmentData has items
  <div>
    {/* Your data rendering logic goes here */}
  </div>
)}
                  </div>
                    
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TodayAppointment;
